@if (filtersParams.length) {
  <div
    class="wrapper"
    [class.filters-visible]="filtersVisibilityService.isFiltersVisible()"
  >
    <button
      mat-button
      class="filter-button"
      [class.filter-button-visible]="filtersVisibilityService.isFiltersVisible()"
      (click)="handleToggleFiltersVisible()"
    >
      <i
        class="filter-icon"
        [class.grey-filter]="isFiltersEmpty()"
      ></i>
    </button>
    @if (filtersVisibilityService.isFiltersVisible()) {
      <button
        class="filter-button-reset"
        mat-button
        [matTooltip]="'Очистить фильтры'"
        [matTooltipShowDelay]="500"
        (click)="handleResetFilter()"
      >
        <i class="filter-reset-icon"></i>
      </button>
    }

    @if (filtersVisibilityService.isFiltersVisible()) {
      <div
        #filtersTable
        class="filters-table"
        @smoothShowHideHeight
        (@smoothShowHideHeight.done)="onFilterAnimationDone()"
      >
        @for (filter of filtersParams; track $index) {
          <div class="filter">
            <div class="filter-title">
              {{ filter.filterName || filter.name }}
            </div>
            <div [class]="[filter.type]">
              @switch (filter.filterType) {
                @case ('DEFAULT') {
                  @switch (filter.type) {
                    @case ('DATE') {
                      <div class="date-wrapper">
                        <mat-date-range-input
                          [formGroup]="dateRanges[filter.key]"
                          [rangePicker]="picker"
                        >
                          <input
                            #dateRangeStart
                            matInput
                            matStartDate
                            appDateInput
                            formControlName="fromPlannedDate"
                            placeholder="Начальная">

                          <input
                            #dateRangeEnd
                            matInput
                            matEndDate
                            appDateInput
                            formControlName="toPlannedDate"
                            placeholder="Конечная"
                            (dateChange)="dateRangeChange(dateRangeStart.value, dateRangeEnd.value, filter)"
                          >
                        </mat-date-range-input>
                        <div class="toggle">
                          <mat-datepicker-toggle
                            matIconSuffix
                            [for]="picker"
                          ></mat-datepicker-toggle>
                          <mat-datepicker-toggle
                            matSuffix
                            (click)="clearDateRange(filter)"
                          >
                            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                          </mat-datepicker-toggle>
                        </div>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </div>
                    }
                    @case ('SELECT') {
                      <app-single-select-table-item
                        [columnParam]="filter"
                        [value]="filtersValues[filter.key]"
                        [isEdit]="true"
                        (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                      />
                    }
                    @case ('ENUM_SELECT') {
                      <app-single-select-table-item
                        [columnParam]="filter"
                        [value]="filtersValues[filter.key]"
                        [isEdit]="true"
                        (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                      />
                    }
                    @case ('TEXT') {
                      <app-text-record-table-item
                        [columnParam]="filter"
                        [value]="filtersValues[filter.key]"
                        [isEdit]="true"
                        [useDynamicWidth]="false"
                        (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                      />
                    }
                    @case ('NUMBER') {
                      <app-number-record-table-item
                        [columnParam]="filter"
                        [value]="filtersValues[filter.key]"
                        [isEdit]="true"
                        [isFilter]="true"
                        [useDynamicWidth]="false"
                        (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                      />
                    }
                    @case ('NUMERIC') {
                      <div class="input-range" (click)="$event.stopPropagation()">
                        <app-number-record-table-item
                          [columnParam]="filter"
                          [value]="filtersValues[getFormToNumberKey(filter.key, 'From')]"
                          [isEdit]="true"
                          [isFilter]="true"
                          [useDynamicWidth]="false"
                          (valueChanged)="handleFiltersValuesChange(getFormToNumberKey(filter.key, 'From'), $event)"
                        />
                        -
                        <app-number-record-table-item
                          [columnParam]="filter"
                          [value]="filtersValues[getFormToNumberKey(filter.key, 'To')]"
                          [isEdit]="true"
                          [isFilter]="true"
                          [useDynamicWidth]="false"
                          (valueChanged)="handleFiltersValuesChange(getFormToNumberKey(filter.key, 'To'), $event)"
                        />
                      </div>
                    }
                    @case ('BOOLEAN') {
                      <app-boolean-record-table-item
                        [columnParam]="filter"
                        [value]="filtersValues[filter.key]"
                        [isEdit]="true"
                        (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                      />
                    }
                  }
                }
                @case ('MULTIPLE_SELECT') {
                  <app-multi-select-table-item
                    [columnParam]="filter"
                    [value]="filtersValues[filter.key]"
                    [isEdit]="true"
                    (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                  />
                }
                @case ('SINGLE_SELECT') {
                  <app-single-select-table-item
                    [columnParam]="filter"
                    [value]="filtersValues[filter.key]"
                    [isEdit]="true"
                    (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                  />
                }
                @case ('PRODUCT_ARTICLE_MULTI_SELECT') {
                  <app-dynamic-multi-select-table-item
                    [columnParam]="filter"
                    [value]="filtersValues[filter.key]"
                    [isEdit]="true"
                    [dynamicValue]="filter.key === 'productId' ? filtersValues['article'] : filtersValues['productId']"
                    (valueChanged)="handleFiltersValuesChange(filter.key, $event)"
                  />
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
